import userTypesConfig from './userTypes';

import pageData from './pageData';

import general from './general';

import languageSelector from './languageSelector';

export default {
  userTypes: userTypesConfig,

  pageData,

  general,

  staticData: languageSelector
};
